import WCrossedOut from './crossed-out.vue';


export const components = {
    WCrossedOut
};

export function registerPreviewComponents(Vue) {
  for (var name in components) {
    // console.log('register:', name);
    Vue.component(name, components[name]);
  }
}


export default components;
